"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositSUI = depositSUI;
exports.withdrawSUI = withdrawSUI;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const transactions_1 = require("@mysten/sui/transactions");
async function depositSUI(amount) {
    const txb = new transactions_1.Transaction();
    const asset = 0;
    const borrow_asset = 5;
    const option = 1;
    const amountInMist = BigInt(amount) * BigInt(1000000000);
    const [depositCoin] = txb.splitCoins(txb.gas, [amountInMist]);
    txb.moveCall({
        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::pool::user_deposit`,
        typeArguments: [
            "0x2::sui::SUI",
            (0, alphafi_sdk_1.getConf)().ALPHA_XSUI_COIN_TYPE,
            (0, alphafi_sdk_1.getConf)().VSUI_COIN_TYPE,
        ],
        arguments: [
            txb.object((0, alphafi_sdk_1.getConf)().ALPHA_SUI_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().ALPHA_SUI_CETUS_INVESTOR),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_SUI_REWARDS_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_SUI_SPOOL),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_VERSION),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_MARKET),
            depositCoin,
            txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
            txb.object((0, alphafi_sdk_1.getConf)().PRICE_ORACLE),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_STORAGE),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_SUI_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_VSUI_BORROW_POOL),
            txb.pure.u8(asset),
            txb.pure.u8(borrow_asset),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V1),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V2),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_VSUI_FUNDS_POOL),
            txb.pure.u8(option),
        ],
    });
    // context.signAndExecute({
    //   transactionBlock: txb,
    // });
}
async function withdrawSUI(context, amount) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const txb = new transactions_1.Transaction();
    const asset = 0;
    const borrow_asset = 5;
    const option = 1;
    let coins = [];
    let cursor = null;
    let hasNextPage = true;
    if (context.currentAccount) {
        do {
            const response = await suiClient.getCoins({
                owner: context.currentAccount.address,
                coinType: (0, alphafi_sdk_1.getConf)().ALPHA_XSUI_COIN_TYPE,
                cursor: cursor,
            });
            coins = coins.concat(response.data);
            cursor = response.nextCursor;
            hasNextPage = response.hasNextPage;
        } while (hasNextPage);
    }
    let coin;
    if (coins.length >= 1) {
        [coin] = txb.splitCoins(txb.object(coins[0].coinObjectId), [0]);
        txb.mergeCoins(coin, coins.map((c) => c.coinObjectId));
    }
    else {
        throw new Error("No xCoins");
    }
    let withdrawCoin = coin;
    if (amount !== "all" && typeof amount === "string") {
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            throw new Error("Invalid amount. Please enter a valid number or 'all'.");
        }
        // TODO check amount less than coin
        [withdrawCoin] = txb.splitCoins(coin, [parsedAmount]);
    }
    else if (amount === "all") {
        withdrawCoin = coin;
    }
    else {
        [withdrawCoin] = txb.splitCoins(coin, [amount]);
    }
    txb.moveCall({
        target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::pool::user_withdraw`,
        typeArguments: [
            "0x2::sui::SUI",
            (0, alphafi_sdk_1.getConf)().ALPHA_XSUI_COIN_TYPE,
            (0, alphafi_sdk_1.getConf)().VSUI_COIN_TYPE,
        ],
        arguments: [
            txb.object((0, alphafi_sdk_1.getConf)().ALPHA_SUI_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().ALPHA_SUI_CETUS_INVESTOR),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_SUI_REWARDS_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_SUI_SPOOL),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_VERSION),
            txb.object((0, alphafi_sdk_1.getConf)().SCALLOP_MARKET),
            txb.object(withdrawCoin),
            txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
            txb.object((0, alphafi_sdk_1.getConf)().PRICE_ORACLE),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_STORAGE),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_SUI_POOL),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_VSUI_BORROW_POOL),
            txb.pure.u8(asset),
            txb.pure.u8(borrow_asset),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V1),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V2),
            txb.object((0, alphafi_sdk_1.getConf)().NAVI_VSUI_FUNDS_POOL),
            txb.pure.u8(option),
        ],
    });
    // context.signAndExecute({
    //   transactionBlock: txb,
    // });
}
// export async function collectRewardSUI(context: SDKContext) {
//   /* TODO: use PTB to collect reward */
// }
//# sourceMappingURL=sui.js.map